export default {
	title: 'Kliniken Delitzsch Eilenburg | Krankenhaus, Fachkliniken & Notfallversorgung',
	gsmaterials: {
		app: {
			scrollTop: {
				offset: 250,
				size: 'md',
				icon: 'i-mdi-chevron-up',
				class: 'z-20 bg-accent right-5 sm:right-10 hover:bg-primary transition-colors duration-300 ease-in-out'
			},
		}
	},
	ui: {
		button: {
			base: 'inline-flex items-center justify-center [&_span]:font-bold no-underline [&_.iconify]:me-2 rounded px-6 lg:px-16 py-4 cursor-pointer transition duration-300 ease-in-out' +
				'[html[data-contrast="high-light"]_&]:text-black! [html[data-contrast="high-light"]_&>span]:text-black [html[data-contrast="high-light"]_&]:hover:bg-gray-200 [html[data-contrast="high-light"]_&]:ring-black [html[data-contrast="high-light"]_&]:ring-2',
			defaultVariants: {
				size: '2xl',
				color: 'primary',
				variant: 'solid'
			},
			compoundVariants: [
				{
					color: 'primary',
					variant: 'solid',
					class: 'hover:bg-accent [html[data-contrast="high-light"]_&]:bg-gray-100 [html[data-contrast="high-dark"]_&]:text-[#ffff00]'
				},
				{
					color: 'accent',
					variant: 'solid',
					class: 'hover:bg-primary hover:text-white [html[data-contrast="high-light"]_&]:bg-gray-100'
				},
				{
					color: 'white',
					variant: 'outline',
					class: 'ring-2 ring-white ring-offset-0 hover:ring-primary focus-visible:ring-offset-2 focus-visible:outline-none focus-visible:ring-primary bg-white hover:bg-primary text-primary hover:text-white'
				},
				{
					color: 'accent',
					variant: 'outline',
					class: 'ring-2 ring-white ring-offset-0 hover:ring-accent bg-white hover:bg-accent text-primary hover:text-white [&_.iconify]:me-0'
				},
				{
					color: 'secondary',
					variant: 'solid',
					class: 'bg-primary-500! hover:bg-primary-500/90!'
				},
				{
					color: 'info',
					variant: 'solid',
					class: 'bg-black! hover:bg-black-/90! [html[data-contrast="high-light"]_&]:bg-white! [html[data-contrast="high-light"]_&]:text-black [html[data-contrast="high-dark"]_&]:ring-2 [html[data-contrast="high-dark"]_&]:ring-white'
				},
				{
					color: 'neutral',
					variant: 'link',
					class: 'bg-transparent hover:text-accent p-0! [&_.iconify]:size-5'
				}
			]
		},
		formField: {
			slots: {
				labelWrapper: 'leading-normal',
				label: 'text-[1rem] lg:text-[1.15rem] text-primary-500 mb-1 font-medium leading-6',

			}
		},
		select: {
			slots: {
				base: 'rounded-md! text-gray-800 focus:ring-primary! focus-visible:ring-primary! focus-visible:ring-1 focus-visible:ring-offset-0',
				group: 'bg-white'
			},
			defaultVariants: {
				size: 'xl',
				color: 'neutral'
			}
		},
		input: {
			slots: {
				base: 'block border-primary hover:border-accent rounded-md! text-gray-800 focus-within:ring-0 focus-visible:ring-primary! focus-visible:ring-1 focus-visible:ring-offset-0'
			},
			defaultVariants: {
				size: 'xl',
				color: 'neutral'
			}
		},
		inputNumber: {
			slots: {
				increment: '[&>button]:size-7.5 [&>button]:px-1 [&>button]:mb-1.5',
				decrement: '[&>button]:size-7.5 [&>button]:px-1'
			}
		},
		textarea: {
			slots: {
				base: 'border-primary hover:border-accent rounded-md! text-gray-800 focus-within:ring-0: focus-visible:ring-primary! focus-visible:ring-1  focus-visible:ring-offset-0',
			},
			defaultVariants: {
				size: 'xl',
				color: 'neutral'
			}
		},
		checkbox: {
			slots: {
				base: 'cursor-pointer size-5! bg-gray-50 ring-primary checked:ring-primary focus-visible:ring-primary focus-visible:ring-2 focus-visible:ring-offset-2',
				label: 'block text-[1rem] text-primary font-normal leading-6 cursor-pointer',
				container: 'flex items-center justify-items-start'
			},
			defaultVariants: {
				color: 'primary',
				variant: 'list',
				indicator: 'start'
			}
		},
		radioGroup: {
			slots: {
				base: 'flex flex-col gap-2',
				item: 'flex items-center gap-2',
				label: 'text-[1rem] lg:text-[1.15rem]! my-0! font-medium leading-6 cursor-pointer'
			}
		},
		radio: {
			slots: {
				base: 'cursor-pointer size-5! ring-primary checked:ring-primary focus-visible:ring-primary focus-visible:ring-2 focus-visible:ring-offset-2',
				label: 'block text-[1rem] text-primary-500 font-normal leading-6 cursor-pointer',
				container: 'flex items-center justify-items-start'
			},
			defaultVariants: {
				color: 'primary',
				variant: 'list',
				indicator: 'start'
			}
		},
		pagination: {
			slots: {
				base: 'flex items-center justify-center',
				list: 'gap-2',
				item: 'aspect-square! px-4! border-0 h-11.5 shadow-none hover:bg-primary hover:[&_span]:text-white ring-gray-300 ring-1 hover:ring-primary focus-visible:ring-accent data-[selected=true]:bg-primary data-[selected=true]:ring-primary',
				prev: 'px-2! border-0 h-11.5 aspect-square shadow-none [&_.iconify]:mr-0 disabled:[&_.iconify]:text-gray-300 hover:bg-primary focus-visible:ring-accent hover:[&_span]:text-white ring-gray-300 ring-1 hover:ring-primary disabled:hover:ring-gray-300',
				next: 'px-2! border-0 h-11.5 aspect-square shadow-none [&_.iconify]:mr-0 disabled:[&_.iconify]:text-gray-300 hover:bg-primary focus-visible:ring-accent hover:[&_span]:text-white ring-gray-300 ring-1 hover:ring-primary disabled:hover:ring-gray-300',
				first: 'px-2! border-0 h-11.5 aspect-square shadow-none [&_.iconify]:mr-0 disabled:[&_.iconify]:text-gray-300 hover:bg-primary focus-visible:ring-accent hover:[&_span]:text-white ring-gray-300 ring-1 hover:ring-primary disabled:hover:ring-gray-300',
				last: 'px-2! border-0 h-11.5 aspect-square shadow-none [&_.iconify]:mr-0 disabled:[&_.iconify]:text-gray-300 hover:bg-primary focus-visible:ring-accent hover:[&_span]:text-white ring-gray-300 ring-1 hover:ring-primary disabled:hover:ring-gray-300',
				label: 'text-center font-medium text-[1.2rem]! min-w-auto'
			}
		},
	}
}
